import { render, staticRenderFns } from "./MessageAction.vue?vue&type=template&id=0c934670&scoped=true"
import script from "./MessageAction.vue?vue&type=script&lang=ts"
export * from "./MessageAction.vue?vue&type=script&lang=ts"
import style0 from "./MessageAction.vue?vue&type=style&index=0&id=0c934670&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c934670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c934670')) {
      api.createRecord('0c934670', component.options)
    } else {
      api.reload('0c934670', component.options)
    }
    module.hot.accept("./MessageAction.vue?vue&type=template&id=0c934670&scoped=true", function () {
      api.rerender('0c934670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/MessageAction.vue"
export default component.exports